import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { PDFAxis } from "../../components/PDFAxis";

export interface IPDFAxisPage {}

export const PDFAxisPage: FC<IPDFAxisPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="PDF Axis"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[{text: 'PDF Axis', navigateTo: '/pdf-axis'}]}
      mainContents={<PDFAxis />}
    />
  );
};
